"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Inspired by https://stackoverflow.com/a/21015393/9962307
var getTextWidth = function getTextWidth(text, font) {
  // re-use canvas object for better performance
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'));
  var context = canvas.getContext('2d');
  if (context) {
    context.font = font;
    var metrics = context.measureText(text);
    return Math.ceil(metrics.width);
  } else {
    return 0;
  }
};
function getCssStyle(element, prop) {
  return window.getComputedStyle(element, null).getPropertyValue(prop);
}
function getCanvasFont(el) {
  el = el || document.body;
  var fontWeight = getCssStyle(el, 'font-weight') || 'normal';
  var fontSize = getCssStyle(el, 'font-size') || '16px';
  var fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman';
  return "".concat(fontWeight, " ").concat(fontSize, " ").concat(fontFamily);
}
var ERROR_MARGIN = 8;
var useInputAutoWidth = function useInputAutoWidth(_ref) {
  var textValue = _ref.textValue,
    anchorEl = _ref.anchorEl;
  var _React$useState = React.useState(ERROR_MARGIN),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    inputWidth = _React$useState2[0],
    setInputWidth = _React$useState2[1];
  React.useEffect(function () {
    setInputWidth(getTextWidth(textValue, getCanvasFont(anchorEl)) + ERROR_MARGIN);
  }, [anchorEl, textValue]);
  return inputWidth;
};
var _default = useInputAutoWidth;
exports["default"] = _default;